export const TITLE = 'Notification Settings';

export const CLASS_NAMES = {
  title: 'text-16-20-em text-neutral-900',
  description: 'tex-14-22 text-neutral-600 mb-6',
};
